module.exports = __webpack_public_path__ + "img/transitions-black.8ca3c21b.svg";